import 'twin.macro';
import React, { useState } from 'react';
import useSchoolyearsWithSchoolsAndClassrooms from 'queries/schoolyears/useSchoolyearsWithSchoolsAndClassrooms';
import { UserLocale } from '@teetsh/app/src/types/user';
import { useGetShareEDTClassrooms } from './useGetShareEDTClassrooms';
import { useDuplicateSharedEDT } from './useDuplicateSharedEDT';
import { useNavigate } from 'react-router-dom';
import { ClassroomsMappingModal } from '@teetsh/app/src/components/EntitiesSelectorModals/ClassroomsMappingModal';

interface Props {
  token: string;
  edtId: string;
  locale: UserLocale;
}

export function DuplicateSharedEDTModal(props: Props) {
  const { token, edtId, locale } = props;

  const [isOpen, setIsOpen] = useState<boolean>(true);
  const onClose = () => setIsOpen(false);

  const { data: srcClassrooms = [] } = useGetShareEDTClassrooms(token, edtId);
  const { data: schoolyears = [] } = useSchoolyearsWithSchoolsAndClassrooms();
  const hasSingleSchoolSchoolyear =
    schoolyears.length === 1 && schoolyears[0].schools.length === 1;

  const duplicate = useDuplicateSharedEDT();
  const navigate = useNavigate();
  const onSubmit = async ({
    schoolyearId: destSchoolyearId,
    schoolId: destSchoolId,
    classroomsMapping,
  }) => {
    if (!destSchoolId || !destSchoolyearId) {
      return Promise.resolve();
    }
    duplicate({
      token,
      weektableId: edtId,
      destSchoolyearId,
      destSchoolId,
      classroomsMapping,
    })
      .then(({ edt }) => {
        navigate(
          `/annee-scolaire/${destSchoolyearId}/ecole/${destSchoolId}/emploi-du-temps/${edt.id}`,
        );
      })
      .catch(err => {
        if (err.response.status !== 403) {
          throw err;
        }
      });
  };

  return (
    <ClassroomsMappingModal
      isOpen={isOpen}
      srcClassrooms={srcClassrooms}
      locale={locale}
      onClose={onClose}
      onSubmit={onSubmit}
      enableCreateClassroom
      enableDateStep={false}
      schoolyear={hasSingleSchoolSchoolyear ? schoolyears[0] : undefined}
    />
  );
}
